import { dataSquareRotation } from 'dls-icons-data'
import { createIcon } from '../common'

const IconSquareRotation = /*#__PURE__*/createIcon(dataSquareRotation)
export default IconSquareRotation
